var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hit-row"},[_c('div',{key:_vm.key,staticClass:"hit-col-md-3"},[_c('div',{staticClass:"hit-form-group"},[_c('label',{staticClass:"hit-html-label",domProps:{"innerHTML":_vm._s(_vm.$t('message.backgroundImage'))}}),_c('uploadImage',{attrs:{"title":_vm.$t('message.edit', {name: _vm.$t('message.banner')}),"settings":{
      image: {dataUrl: _vm.vals.background_image},
      maxWidth: 1000,
      maxHeight: 1000,
      onSave: function(ret){ _vm.callback(ret.dataUrl); },
      debug: 0,
      accept: 'image/*'
    }}})],1),_c('div',{staticClass:"hit-text-right"},[_c('a',{staticClass:"hit-btn hit-btn-default hit-btn-xs",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return (function(){ _vm.callback(''); _vm.vals.background_image = ''; _vm.key = new Date().getTime(); }).apply(null, arguments)}}},[_c('hit_icon',{attrs:{"id":'bin'}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }